import React, { useCallback } from 'react';

import i18next from '@bonanza-social/i18n';
import {
  Lang,
  usePreferredLanguage,
} from '../../hooks/useLanguageSwitcherHooks';
import LanguageInlineSelector from './LanguageInlineSelector/LanguageInlineSelector';
import LanguageRadioSelector from './LanguageRadioSelector/LanguageRadioSelector';

type LanguageSwitcherProps = {
  lang?: Lang;
  variant?: 'inline' | 'radios';
  title?: string;
  onLanguageSwitch?: (lang: Lang) => void;
  applyImmediately?: boolean;
};

function LanguageSwitcher({
  lang,
  variant = 'inline',
  title,
  onLanguageSwitch,
  applyImmediately = true,
}: LanguageSwitcherProps) {
  const { storePreferredLanguage } = usePreferredLanguage();
  const language = i18next.language as Lang;

  const handleLanguageSelect = useCallback(
    (selectedLang: Lang) => {
      if (applyImmediately) {
        storePreferredLanguage(selectedLang);
      }

      onLanguageSwitch?.(selectedLang);
    },
    [applyImmediately, storePreferredLanguage, onLanguageSwitch],
  );

  return variant === 'inline' ? (
    <LanguageInlineSelector lang={language} onSelect={handleLanguageSelect} />
  ) : (
    <LanguageRadioSelector
      lang={lang ?? language}
      onSelect={handleLanguageSelect}
      title={title}
    />
  );
}

export default LanguageSwitcher;
